import { FC } from "react";
import { FeatureAccordion } from "ui-library";
import { accordion } from "types/CMS/Unum/accordion";
import { PortableText } from "@kontent-ai/rich-text-resolver/utils/react";
import useInternalExternalNavigate from "hooks/CMS/useInternalExternalNavigate/useInternalExternalNavigate";

const EmployerFeatureAccordion: FC<{ section: accordion }> = ({ section }) => {
  const internalExternalNavigate = useInternalExternalNavigate();
  return (
    <FeatureAccordion
      items={[
        {
          subtitle: section.subtitle,
          title: section.title,
          color: "white",
          featureProps: {
            alignItem: "right",
            assetType: section.asset.type ?? "image",
            content: <PortableText {...section.body} />,
            src: section.asset.url,
            buttonOneLabel: section?.cta[0] && section?.cta[0]?.label,
            buttonTwoLabel: section?.cta[1] && section?.cta[1]?.label,
            buttonThreeLabel: section.cta[2] && section?.cta[2].label,
            buttonOneAction: () => {
              internalExternalNavigate(section.cta?.[0]);
            },
            buttonTwoAction: () => {
              internalExternalNavigate(section.cta?.[1]);
            },
            buttonThreeAction: () => {
              internalExternalNavigate(section.cta?.[2]);
            },
          },
        },
      ]}
      label="featureAccordionLabel"
      size="medium"
      spaceBetween
      variant="default"
    />
  );
};

export default EmployerFeatureAccordion;
